"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginButtonLink = exports.LoginLink = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_router_link_1 = require("@hotelplan/components.common.router-link");
const graphql_types_1 = require("@hotelplan/graphql.types");
const libs_router_config_1 = require("@hotelplan/libs.router-config");
const libs_router_link_utils_1 = require("@hotelplan/libs.router-link-utils");
function LoginRouterLink({ children, language, query, }) {
    const route = (0, libs_router_config_1.getRouteByPageTypeLocale)(graphql_types_1.PageType.MyaccountLogin, language);
    const pathname = route === null || route === void 0 ? void 0 : route.builder({});
    const routerProps = (0, libs_router_link_utils_1.getTargetPageData)({
        targetPageType: route === null || route === void 0 ? void 0 : route.pageType,
        uri: pathname,
    });
    return (react_1.default.createElement(components_common_router_link_1.RouterLink, { href: {
            pathname: route === null || route === void 0 ? void 0 : route.page,
            query,
        }, as: {
            pathname,
            query,
        }, locale: routerProps === null || routerProps === void 0 ? void 0 : routerProps.locale, passHref: true }, children));
}
function LoginLink({ children, language, className, query, }) {
    return (react_1.default.createElement(LoginRouterLink, { language: language, query: query },
        react_1.default.createElement("a", { className: className }, children)));
}
exports.LoginLink = LoginLink;
exports.LoginButtonLink = (0, styled_components_1.default)(LoginLink)(({ theme }) => theme.buttons.primary, {
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    textAlign: 'center',
    ':hover': {
        color: 'white',
    },
});
exports.default = LoginRouterLink;
//# sourceMappingURL=LoginRouterLink.js.map